import { formatDate } from '@/lib/format';

/**
 * Smart applied-period range for invoice rows: `DD/MM/YYYY → DD/MM/YYYY`,
 * dropping the year from the start date when both dates share the same year
 * (mirrors the legacy `createTimeRangeFormatter({ smartYear: true })`).
 */
export function appliedRange(start?: string | null, end?: string | null): string {
  if (!start && !end) return '—';
  if (!start) return formatDate(end);
  if (!end) return formatDate(start);

  const s = new Date(start);
  const e = new Date(end);
  const sameYear =
    !isNaN(s.getTime()) && !isNaN(e.getTime()) && s.getFullYear() === e.getFullYear();

  const startLabel = sameYear
    ? `${String(s.getDate()).padStart(2, '0')}/${String(s.getMonth() + 1).padStart(2, '0')}`
    : formatDate(start);

  return `${startLabel} → ${formatDate(end)}`;
}
